// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/root.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/root.tsx");
}
// REMIX HMR END

import { cssBundleHref } from '@remix-run/css-bundle';
import { isRouteErrorResponse, Link, Links, LiveReload, Meta, Outlet, Scripts, ScrollRestoration, useLoaderData, useRouteError } from '@remix-run/react';
import stylesheet from './tailwind.css';
import { Header } from './components/header/Header';
import { json } from '@remix-run/server-runtime';
import { getCollections } from '~/providers/collections/collections';
import { activeChannel } from '~/providers/channel/channel';
import { APP_META_DESCRIPTION, APP_META_TITLE } from '~/constants';
import { useEffect, useState } from 'react';
import { CartTray } from '~/components/cart/CartTray';
import { getActiveCustomer } from '~/providers/customer/customer';
import Footer from '~/components/footer/Footer';
import { useActiveOrder } from '~/utils/use-active-order';
import { useChangeLanguage } from 'remix-i18next';
import { useTranslation } from 'react-i18next';
import { getI18NextServer } from '~/i18next.server';
export const meta = () => {
  return [{
    title: APP_META_TITLE
  }, {
    description: APP_META_DESCRIPTION
  }];
};
export const links = () => [{
  rel: 'stylesheet',
  href: stylesheet
}, ...(cssBundleHref ? [{
  rel: 'stylesheet',
  href: cssBundleHref
}] : [])];
const devMode = typeof process !== 'undefined' && process.env.NODE_ENV === 'development';

// The root data does not change once loaded.
export const shouldRevalidate = ({
  nextUrl,
  currentUrl,
  formAction
}) => {
  /* 
  if (currentUrl.pathname === '/sign-in') {
    // just logged in
    return true;
  }   Header needs to rerender everywhere*/
  return true;
  /*  if (currentUrl.pathname === '/account' && nextUrl.pathname === '/') {
    // just logged out
    return true;
  }
  if (formAction === '/checkout/payment') {
    // submitted payment for order
    return true;
  }
  return false; */
};

export async function loader({
  request,
  params,
  context
}) {
  const collections = await getCollections(request, {
    take: 20
  });
  const topLevelCollections = collections.filter(collection => collection.parent?.name === '__root_collection__');
  const activeCustomer = await getActiveCustomer({
    request
  });
  const i18next = await getI18NextServer();
  // Force Czech as default
  const locale = 'cs';
  const loaderData = {
    activeCustomer,
    activeChannel: await activeChannel({
      request
    }),
    collections: topLevelCollections,
    locale,
    env: {
      PUBLIC_HEADER_COLLECTION_LIMIT: process.env.PUBLIC_HEADER_COLLECTION_LIMIT,
      PUBLIC_INDEX_COLLECTION_LIMIT: process.env.PUBLIC_INDEX_COLLECTION_LIMIT,
      PUBLIC_PRODUCT_LIST_COLUMNS: process.env.PUBLIC_PRODUCT_LIST_COLUMNS
    }
  };
  return json(loaderData, {
    headers: activeCustomer._headers
  });
}
export async function action({
  params,
  request
}) {
  const formData = await request.formData();
  const errors = {};
  const quantities = {};
  let sum = 0;
  for (const [key, value] of formData.entries()) {
    if (key.startsWith('quantity-')) {
      const id = key.split('-')[1];
      const quantity = Number(value);
      sum += quantity;
      // Custom validation (e.g., quantity must be >= 1)
      if (isNaN(quantity) || quantity < 1 || quantity > 100) {
        errors[key] = `Quantity must be 1 or more and less than 100.`;
      } else {
        quantities[id] = quantity;
      }
    }
  }
  // If errors exist, return them to the UI
  if (Object.keys(errors).length > 0) {
    return {
      errors,
      success: false
    };
  } else {
    return {
      success: true
    };
  }
}
export default function App() {
  _s();
  const [open, setOpen] = useState(false);
  const loaderData = useLoaderData();
  const {
    collections
  } = loaderData;
  const {
    locale
  } = useLoaderData();
  const {
    i18n
  } = useTranslation();
  const {
    activeOrderFetcher,
    activeOrder,
    adjustOrderLine,
    removeItem,
    refresh
  } = useActiveOrder();
  useChangeLanguage(locale);
  useEffect(() => {
    // When the loader has run, this implies we should refresh the contents
    // of the activeOrder as the user may have signed in or out.
    refresh();
    // Set Czech as default language only if no language is set
    if (!localStorage.getItem('selectedLanguage')) {
      localStorage.setItem('selectedLanguage', 'cs');
      i18n.changeLanguage('cs');
    }
  }, [loaderData]);
  return <html lang={locale} dir={i18n.dir()} id="app">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <script type="text/javascript" src="//cdn.cookie-script.com/s/fe3def583bcc8e78f51d3eae5f035166.js">
        </script>
       
        {/* Google Tag Manager */}
        <script dangerouslySetInnerHTML={{
        __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GT-TQL6MZ2C');`
      }} />

        {/* End Google Tag Manager */}

        <script type='text/javascript'>
          {`
            window.smartlook||(function(d) {
              var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
              var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
              c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
              })(document);
              smartlook('init', 'f04ec41c8c6e52493c425de0e40d78f3ef7ba91f', { region: 'eu' });
          `}
        </script>
        <link rel="icon" href="/logo.svg" type="image/svg"></link>
        <Meta />
        <Links />
      </head>
      <body>
        {/* Google Tag Manager (noscript) */}
        <noscript>
          <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KS2GT6WN" height="0" width="0" style={{
          display: 'none',
          visibility: 'hidden'
        }}>
          </iframe>
        </noscript>
        {/* End Google Tag Manager (noscript) */}
        
        <div className="flex flex-col min-h-screen justify-between">
          <div>
            <Header onCartIconClick={() => setOpen(!open)} cartQuantity={activeOrder?.totalQuantity ?? 0} />

            <main className="">
              <Outlet context={{
              activeOrderFetcher,
              activeOrder,
              adjustOrderLine,
              removeItem
            }} />

            </main>
          </div>

          <Footer collections={collections}></Footer>
        </div>

        <CartTray open={open} onClose={setOpen} activeOrder={activeOrder} adjustOrderLine={adjustOrderLine} removeItem={removeItem} />

        <ScrollRestoration />
        <Scripts />
        {devMode && <LiveReload />}
      </body>
    </html>;
}
_s(App, "S/yjElHTGOHJYWCdrAYtOa+UIwU=", false, function () {
  return [useLoaderData, useLoaderData, useTranslation, useActiveOrder, useChangeLanguage];
});
_c = App;
/**
 * You should replace this in your actual storefront to provide a better user experience.
 * You probably want to still show your footer and navigation. You will also need fallbacks
 * for your data dependant components in case your shop instance / CMS isnt responding.
 * See: https://remix.run/docs/en/main/route/error-boundary
 */
function DefaultSparseErrorPage({
  tagline,
  headline,
  description
}) {
  return <html lang="en" id="app">
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <link rel="icon" type="image/svg" href="/logo.svg"></link>
        <Meta />
        <Links />
      </head>
      <body>
        <main className="flex flex-col items-center px-4 py-16 sm:py-32 text-center">
          <span className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
            {tagline}
          </span>
          <h1 className="mt-2 font-bold text-gray-900 tracking-tight text-4xl sm:text-5xl">
            {headline}
          </h1>
          <p className="mt-4 text-base text-gray-500 max-w-full break-words">
            {description}
          </p>
          <div className="mt-6">
            <Link to="/" className="text-base font-medium text-primary-600 hover:text-primary-500 inline-flex gap-2">

              Go back home
            </Link>
          </div>
        </main>
        <ScrollRestoration />
        <Scripts />
        {devMode && <LiveReload />}
      </body>
    </html>;
}

/**
 * As mentioned in the jsdoc for `DefaultSparseErrorPage` you should replace this to suit your needs.
 */
_c2 = DefaultSparseErrorPage;
export function ErrorBoundary() {
  _s2();
  let tagline = 'Oopsy daisy';
  let headline = 'Unexpected error';
  let description = "We couldn't handle your request. Please try again later.";
  const error = useRouteError();
  if (isRouteErrorResponse(error)) {
    tagline = `${error.status} error`;
    headline = error.statusText;
    description = error.data;
  }
  return <DefaultSparseErrorPage tagline={tagline} headline={headline} description={description} />;
}

/**
 * In Remix v2 there will only be a `ErrorBoundary`
 * As mentioned in the jsdoc for `DefaultSparseErrorPage` you should replace this to suit your needs.
 * Relevant for the future: https://remix.run/docs/en/main/route/error-boundary-v2
 */
_s2(ErrorBoundary, "oAgjgbJzsRXlB89+MoVumxMQqKM=", false, function () {
  return [useRouteError];
});
_c3 = ErrorBoundary;
export function CatchBoundary() {
  return ErrorBoundary();
}
_c4 = CatchBoundary;
var _c, _c2, _c3, _c4;
$RefreshReg$(_c, "App");
$RefreshReg$(_c2, "DefaultSparseErrorPage");
$RefreshReg$(_c3, "ErrorBoundary");
$RefreshReg$(_c4, "CatchBoundary");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;